import { TableCell, TableRow, Typography } from '@mui/material';
import { OfflineBudgetNestedTableRowData } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import { formatNumberWithSpaces } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/formatNumberWithSpaces';

interface OutdoorsTouchpointTableRowProps {
  row: OfflineBudgetNestedTableRowData;
}

function OutdoorsTouchpointTableRow({ row }: OutdoorsTouchpointTableRowProps) {
  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2">{row.type}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{row.option}</Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2">
          {`${formatNumberWithSpaces(row.budget.value.toFixed(0))} ${
            row.budget.currency
          }`}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default OutdoorsTouchpointTableRow;
